module.exports = __webpack_public_path__ + "media/src/assets/Images/Counter-19276822bd0a0e742c050929856a941a.svg";